//#region src/utils/formatClipDuration.ts
function e(e) {
	let t = Number.isFinite(e) && e > 0 ? Math.floor(e) : 0;
	return `${Math.floor(t / 60)}:${(t % 60).toString().padStart(2, "0")}`;
}
//#endregion
export { e as formatClipDuration };
